import { render, staticRenderFns } from "./inheritDetails.vue?vue&type=template&id=7705152d&scoped=true&"
import script from "./inheritDetails.vue?vue&type=script&lang=js&"
export * from "./inheritDetails.vue?vue&type=script&lang=js&"
import style0 from "./inheritDetails.vue?vue&type=style&index=0&id=7705152d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705152d",
  null
  
)

export default component.exports